import { styled } from 'baseui';
import { CSS_VARIABLE_STAGE_ROTATION, CSS_VARIABLE_STAGE_VISIBLE_SCALE } from '../../../constants/stage-css-variables';
export const LabelText = styled<'text', {
  $originX: number;
  $originY: number;
  // Draws a black outline behind the text so labels stay legible on top of
  // arbitrary image backgrounds. Opt-in: contexts with a controlled
  // background (e.g. the template preview) should leave it off.
  $outlined?: boolean;
}>('text', ({
  $theme,
  $originX,
  $originY,
  $outlined
}) => ({
  ...$theme.typography.HeadingXSmall,
  fill: $theme.colors.white,
  ...($outlined ? {
    stroke: $theme.colors.black,
    strokeWidth: $theme.sizing.scale100,
    strokeLinejoin: 'round',
    paintOrder: 'stroke'
  } : {}),
  fontWeight: 'initial',
  direction: 'ltr',
  userSelect: 'none',
  fontSize: 'smaller',
  transformOrigin: `${$originX}px ${$originY}px`,
  transform: `rotate(calc(-1 * var(${CSS_VARIABLE_STAGE_ROTATION}))) scale(var(${CSS_VARIABLE_STAGE_VISIBLE_SCALE}))`
}));